import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var createOutlineStyles = function createOutlineStyles(options) {
  var _ref = options,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 9 : _ref$borderRadius,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? {
    x: 0,
    y: 0
  } : _ref$offset;
  return _objectSpread(_objectSpread({}, styles), {}, {
    position: 'relative',
    '&:before': {
      borderRadius: borderRadius,
      borderColor: 'var(--wcds-btn-border-color-focus)',
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow: '0 0 0 3px var(--wcds-colors-focus-ring-default), 0 0 0 7px var(--wcds-btn-border-color-focus)',
      content: "''",
      position: 'absolute',
      top: offset.y,
      bottom: offset.y,
      left: offset.x,
      right: offset.x
    }
  });
};
/**
 * Default focus outline styles
 */

export var outlines = {
  "default": createOutlineStyles({}),
  withOffset: createOutlineStyles({
    borderRadius: 4,
    offset: {
      x: -4,
      y: -4
    }
  }),
  withoutOffset: createOutlineStyles({
    borderRadius: 4,
    offset: {
      x: 0,
      y: 0
    }
  }),
  defaultOutline: createOutlineStyles({})
};
export default {
  createOutlineStyles: createOutlineStyles,
  outlines: outlines
};